const state = {
    sidebar: {

    },
}

const mutations = {
    TOGGLE_SIDEBAR: state => {
        return state
    },
}

// 所有的mutations转换成actions进行调用
const actions = {
    toggleSideBar({ commit }) {
        commit('TOGGLE_SIDEBAR')
    },
}

export default {
    namespaced: true,
    state,
    mutations,
    actions
}
